import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "subservice-header-title-container" }
const _hoisted_2 = { class: "subservice-header-btn-container" }
const _hoisted_3 = { class: "subservice-header-menu" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_breadcrumbs_el = _resolveComponent("q-breadcrumbs-el")!
  const _component_q_breadcrumbs = _resolveComponent("q-breadcrumbs")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_q_breadcrumbs, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_breadcrumbs_el, { label: _ctx.menu }, null, 8, ["label"]),
          _createVNode(_component_q_breadcrumbs_el, {
            label: _ctx.service,
            to: _ctx.service_path
          }, null, 8, ["label", "to"]),
          _createVNode(_component_q_breadcrumbs_el, { label: _ctx.subservice }, null, 8, ["label"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.isBtnBackEnable)
          ? (_openBlock(), _createBlock(_component_q_btn, {
              key: 0,
              color: "primary",
              label: "Regresar",
              onClick: _ctx.onBackBtn
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.isBtnExportEnable)
          ? (_openBlock(), _createBlock(_component_q_btn, {
              key: 1,
              color: "primary",
              label: "Exportar",
              onClick: _ctx.onExportBtn
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (opt, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass((opt.active) ? 'subservice-header-menu-opt-active' : 'subservice-header-menu-opt'),
          onClick: ($event: any) => (_ctx.selectOption(opt))
        }, _toDisplayString(opt.name), 11, _hoisted_4))
      }), 128))
    ])
  ], 64))
}